import { render, staticRenderFns } from "./AboutRtap.vue?vue&type=template&id=287d9416&scoped=true&"
var script = {}
import style0 from "./AboutRtap.vue?vue&type=style&index=0&id=287d9416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d9416",
  null
  
)

export default component.exports